import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';

export const isCustomerAllowedForSelfCreatedTechnicianVisit = createAsyncThunk(
  'selfCreatedTechnicianVisitSlice/isCustomerAllowedForSelfCreatedTechnicianVisit',
  async (data, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('isCustomerAllowedForSelfCreatedTechnicianVisit', []);
      return result;
    } catch (error) {
      return error;
    }
  }
);

export const setSelfCreatedTechnicianVisit = createAsyncThunk(
  'selfCreatedTechnicianVisitSlice/setSelfCreatedTechnicianVisit',
  async (data, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('SetSlotsStandAlone', [
        data.IdNumber,
        data.ServiceId,
        data.Date,
        data.StartTime,
        data.EndTime,
        data.CityCode,
        data.StreetCode,
        data.StreetName,
        data.MatHouseNum,
        data.MatFlatNum,
        data.DeptId,
        data.DescrTask,
        data.TashtitType,
        data.Enter,
      ]);
      return result;
    } catch (error) {
      return error;
    }
  }
);

const initialState = {
  isShowTechnicianComponent: false,
  customerAddress: {},
  newTechnicianArrivalTime: null,
  isSlotUpdatedSuccessfully: false,
  isLoading: false,
  page: '',
  error: {isDisplay: false, id: 0},
};

const selfCreatedTechnicianVisitSlice = createSlice({
  name: 'selfCreatedTechnicianVisitSlice',
  initialState: initialState,

  reducers: {
    setError: (state, action) => {
      state.error.isDisplay = action.payload.isDisplay;
      state.error.id = action.payload.id;
    },
    setIsSubmit: (state, action) => {
      state.isSubmit = action.payload.isSubmit;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setNewTechnicianArrivalTime: (state, action) => {
      state.newTechnicianArrivalTime = action.payload;
    },
    clearState: (state, action) => {
      state.isLoading = false;
      state.isSlotUpdatedSuccessfully = false;
      state.newTechnicianArrivalTime = null;
      state.error.isDisplay = false;
      state.error.id = 0;
      state.isShowTechnicianComponent = false;
      state.customerAddress = {};
    },
    goToPage: {
      reducer(state, action) {
        state.page = action.payload;
      },
    },
  },
  extraReducers: {
    [isCustomerAllowedForSelfCreatedTechnicianVisit.fulfilled]: (state, action) => {
      if (action.payload.Body) {
        state.isShowTechnicianComponent = true;
        state.customerAddress = action.payload.Body;
      } else {
        state.isShowTechnicianComponent = false;
        state.error.isDisplay = true;
        state.error.id = 63;
      }
    },
    [setSelfCreatedTechnicianVisit.fulfilled]: (state, action) => {
      state.isLoading = false;
      if (action.payload.Body == 1) {
        state.isShowTechnicianComponent = false;
        state.isSlotUpdatedSuccessfully = true;
      } else {
        state.isShowTechnicianComponent = false;
        state.error.isDisplay = true;
        state.error.id = 63;
      }
    },
  },
});

export const {setError, setIsSubmit, setNewTechnicianArrivalTime, setIsLoading, goToPage, clearState} =
  selfCreatedTechnicianVisitSlice.actions;

export default selfCreatedTechnicianVisitSlice.reducer;
